import React, { Component } from 'react'
import Templates from '../../../../../../../api/Templates'
import Employees from '../../../../../../../api/Employees'
import LabourContracts from '../../../../../../../api/People/LabourContracts'
import { idMaker, strVal } from '../../../../../../../modules/Utils'
import { message } from 'antd'
import { get, omit, pick } from 'lodash'
import AddWorkOrders from './AddWorkOrders'
import Members from '../../../../../../../api/Members'

class AddWorkOrdersCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      current: 0,
      workOrder: { rates: [] },
      contract: {},
      keyAtr: 'key',
      employee: {},
      member: {},
      workOrderKey: get(props.match, 'params.workOrderKey'),
      contractKey: get(props.match, 'params.contractKey'),
      id: props.match.params.key,
      type: get(props.match, 'params.workOrderKey') ? 'update' : 'new',
    }
  }

  componentDidMount() {
    this.fetch()
  }

  templateApi = new Templates()
  employeesApi = new Employees()
  memberApi = new Members()
  api = new LabourContracts()
  ids = idMaker()
  keyTermsRef = React.createRef()
  workingConditionsRef = React.createRef()
  compensationRef = React.createRef()

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      let workOrder = {}
      const employeeResponse = await this.employeesApi.getMember(this.state.id)
      const memberResponse = await this.memberApi.get(this.state.id)
      let contract = await this.api.get(this.state.contractKey)
      if (this.state.type === 'update') {
        workOrder = await this.api.workOrder.get(this.state.workOrderKey)
      } else {
        let employeeTemplate = await this.templateApi.read(
          strVal(contract, 'company._id').replace('members/', ''),
          'employee'
        )
        workOrder = employeeTemplate['workOrder'] || {}
      }
      let member = await memberResponse.json()
      let employee = await employeeResponse.json()
      this.setState({
        member,
        employee,
        contract,
        workOrder,
        fetching: false,
        employeeFetching: false,
      })
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        employeeFetching: false,
      })
    }
  }

  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }
  next = async () => {
    let valid = false
    this.setState({
      showSkip: true,
    })
    switch (this.state.current) {
      case 0:
        valid = await this.checkKeyTermsForm()
        break
      case 1:
        valid = await this.checkWorkingConditionsForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current, showSkip: false })
    }
  }
  submit = async () => {
    let valid = false
    try {
      valid = await this.checkCompensationForm()
      if (valid) {
        this.setState({ submitting: true })
        let { workOrder } = this.state
        workOrder = {
          ...workOrder,
          contract: pick(this.state.contract, ['_id', 'code']),
        }
        await this.api.workOrder.create(workOrder)
        message.success('Created !')
        this.props.history.replace({
          pathname: `/people/member/${this.state.id}/contracts/${this.state.contractKey}/view`,
          hash: 'work-orders',
        })
      }
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({ submitting: false })
    }
  }
  update = async () => {
    let valid = false
    try {
      valid = await this.checkCompensationForm()
      if (valid) {
        this.setState({ submitting: true })
        let { workOrder } = this.state
        workOrder = {
          ...workOrder,
          contract: pick(this.state.contract, ['_id', 'code']),
        }
        workOrder = omit(workOrder, ['_history', 'status', 'code', 'revision'])
        await this.api.workOrder.update(workOrder)
        this.setState({ submitting: false })
        message.success('Updated')
        this.props.history.replace({
          pathname: `/people/member/${this.state.id}/contracts/${this.state.contractKey}/workOrders/${this.state.workOrderKey}/view`,
        })
      }
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({ submitting: false })
    }
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }
  checkKeyTermsForm = () => {
    return new Promise((res, rej) => {
      this.keyTermsRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  checkCompensationForm = () => {
    return new Promise((res, rej) => {
      this.compensationRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  checkWorkingConditionsForm = () => {
    return new Promise((res, rej) => {
      this.workingConditionsRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  updateWorkOrder = (attribute, value) => {
    const workOrder = this.state.workOrder
    this.setState({
      workOrder: Object.assign({}, workOrder, { [attribute]: value }),
    })
  }

  add = () => {
    const { workOrder } = this.state
    const newData = workOrder.rates ? [...workOrder.rates] : []
    newData.push({ [this.state.keyAtr]: this.ids.next().value, editable: true })
    this.setState((prvState) => ({
      workOrder: { ...prvState.workOrder, rates: newData },
    }))
  }
  cancel = (_key) => {
    const { workOrder } = this.state
    const newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === [this.state.keyAtr])
        this.remove(target[this.state.keyAtr])
      else
        this.setState((prvState) => ({
          workOrder: { ...prvState.workOrder, rates: newData },
        }))
    }
  }
  remove = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    newData = newData.filter((item) => _key !== item[this.state.keyAtr])
    this.setState((prvState) => ({
      workOrder: { ...prvState.workOrder, rates: newData },
    }))
  }
  edit = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      target.editable = true
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }
  save = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      delete target.editable
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }
  handleChange = (value, _key, column) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.filter((item) => _key === item[this.state.keyAtr])[0]
    if (target) {
      target[column] = value
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }
  skip = () => {
    const current = this.state.current + 1
    this.setState({ current, showSkip: false })
  }

  render() {
    return (
      <AddWorkOrders
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetchRatesTemplate',
          'fetchUOM',
          'fetchPayPeriod',
          'prev',
          'next',
          'skip',
          'submit',
          'update',
          'add',
          'cancel',
          'remove',
          'edit',
          'save',
          'handleChange',
          'keyTermsRef',
          'workingConditionsRef',
          'compensationRef',
        ])}
      />
    )
  }
}

AddWorkOrdersCont.propTypes = {}
AddWorkOrdersCont.defaultProps = {}

export default AddWorkOrdersCont
